import { CheckIcon } from "lucide-react";
import React from "react";

interface IProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  id?: string;
}

const CustomCheckBox = ({ checked, onChange, id = "" }: IProps) => {
  let windowWidth = window.innerWidth;
  return (
    // <div id={`${id}`} className='w-[14px] 2xl:w-[18px] aspect-square border border-[#00443f] rounded-sm 2xl:rounded flex items-center justify-center cursor-pointer' onClick={() => onChange(!checked)}>
    //     {checked && (
    //         <div className='w-full h-full theme-bg-green-dark'>
    //             <CheckIcon size={windowWidth < 768 && windowWidth > 1680 ? 8 : 14} color='white' />
    //         </div>
    //     )}
    // </div>
    <input
      type="checkbox"
      checked={checked}
      onChange={() => onChange(!checked)}
      id={id}
      className="w-[14px] 2xl:w-[18px] accent-[#00443F] aspect-square border border-[#00443f] rounded-sm 2xl:rounded flex items-center justify-center cursor-pointer"
    />
  );
};

export default CustomCheckBox;
